(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-header"] && !Shopify.designMode) return;
  try {
    
  function changeBackgroundImage(buttonElement) {
    const newBackgroundImage = buttonElement.getAttribute('data-background-image');
    const newMobileBackgroundImage = buttonElement.getAttribute('data-mobile-background-image') || newBackgroundImage;
    const newMobilePositionY = buttonElement.getAttribute('data-mobile-position-y') || '50%';
    const buttonLink = buttonElement.getAttribute('data-link');
    const backgroundElement = document.querySelector('.image-with-text-overlay__bg-image');

    function applyActiveTestColor() {
      applyColor(activeTest?.list || myopiaControlList, activeTest?.name || 'myopia-management');
    }

    if (backgroundElement && newBackgroundImage) {
      backgroundElement.style.setProperty('--collection-hero-desktop-image', 'url("' + newBackgroundImage + '")');
      backgroundElement.style.setProperty('--collection-hero-mobile-image', 'url("' + newMobileBackgroundImage + '")');
      backgroundElement.style.setProperty('--collection-hero-mobile-position-y', newMobilePositionY);

      // Handle the link if one is provided
      if (buttonLink && buttonLink !== '') {
        // Add a small delay before navigating to the link
        setTimeout(function () {
          window.location.href = buttonLink;
        }, 200);
      }
    } else if (buttonLink && buttonLink !== '') {
      // If there's no image but there is a link, navigate directly
      window.location.href = buttonLink;
    }
  }

  document.addEventListener('DOMContentLoaded', function () {

    function getTherapyAndRecommendationFromUrl() {
    const params = new URLSearchParams(window.location.search);
    return {
        collectionFilter: params.get('collection_filter') || null,
        therapy: params.get('therapy') || null,
        recommendation: params.get('recommendation') || null
    };
}
    if (document.querySelector('.image-with-text-overlay__bg-image[data-bgset]')) {
      // Initialize parallax effect if enabled
      const parallaxElements = document.querySelectorAll('.image-with-text-overlay__bg-image');
      if (parallaxElements.length > 0) {
        function updateParallax() {
          parallaxElements.forEach(function (element) {
            if (element.closest('[data-section-id]').getAttribute('data-image-parallax') === 'true') {
              var scrollPosition = window.pageYOffset;
              var elementPosition = element.getBoundingClientRect().top + scrollPosition;
              var distance = scrollPosition - elementPosition;
              var transformValue = 'translate3d(0, ' + distance * 0.4 + 'px, 0)';

              element.style.transform = transformValue;
            }
          });
        }

        window.addEventListener('scroll', updateParallax);
        window.addEventListener('resize', updateParallax);

        // Initial call
        updateParallax();
      }
    }

    // Add click handlers to all button elements
    const buttons = document.querySelectorAll('.image-with-text-overlay__button-wrapper .btn');
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        window.collectionHeaderFunctions.changeBackgroundImage(this);
      });
    });

    // Set the first button as active by default for each section
    const sections = document.querySelectorAll('.image-with-text-overlay');
    sections.forEach(function (section) {
      const sectionButtons = section.querySelectorAll('.image-with-text-overlay__button-wrapper .btn');

      let  buttonChoice = 0 ;
      if (sectionButtons.length > 0) {


     const { collectionFilter, therapy, recommendation } = getTherapyAndRecommendationFromUrl();

      const therapyOptions = [
        { key: 'readingTestResult', button: 3, name: 'Reading Assistance' },
        { key: 'colorBlindTestResult', button: 4, name: 'Color Enhancement' },
        { key: 'migraineTestResult', button: 2, name: 'Migraine Relief' },
      ];

      let buttonChoice = null;

      if (therapy) {
          buttonChoice = therapyOptions.find(option => option.name === therapy);
      }

      const setActiveTab = (buttonOrIndex) => {
          const btn = typeof buttonOrIndex === 'number' ? sectionButtons[buttonOrIndex] : buttonOrIndex;
          if (!btn) return;
          btn.classList.add('active-tab');
          if (btn.getAttribute('data-background-image')) {
            window.collectionHeaderFunctions.changeBackgroundImage(btn);
          }
        };

      if (collectionFilter) {
        const matchingButton = Array.from(sectionButtons).find((button) => button.getAttribute('data-collection') === collectionFilter);
        if (matchingButton) {
          setActiveTab(matchingButton);
          return;
        }
      }

      if (therapy && buttonChoice) {
        setActiveTab(buttonChoice.button);
      } else {
        setActiveTab(0); // default
      }


        // Trigger click on first button to load its image (if any)
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
